export const getCurrentMonth = () => {
  let today = new Date();
  let month = today.getMonth() + 1;
  return [today.getFullYear(), month];
};
